import React from 'react'
import './header.scss';
import ArticleDetailsWrapper from '../articleDetailsWrapper';
import RelatedArticle from '../relatedArticle';
import { Helmet } from 'react-helmet';

function InsightDetailWrapper(props) {
  const {data,module} = props;
  return (
    <div className='details-wrapper'>
      <Helmet>
      <title>{data?.title}</title>
      {data && data.meta && Array.isArray(data.meta) && data.meta.map((mt) => (
        <meta key={mt} name="description" content={mt} />
      ))}
      
    </Helmet>
      <ArticleDetailsWrapper jsonData={data} />
        {data && <RelatedArticle relatedArticles={data.relatedArticles} module={module} />}
      

    </div>
  )
}

export default InsightDetailWrapper;
